import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col h-screen overflow-clip" }
const _hoisted_2 = { class: "flex flex-col h-full gap-4 overflow-auto grow" }

import { computed } from "vue";
import { useRouter } from "vue-router";
import "./assets/tailwind.css";
import NavBar from "./components/layout/NavBar.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const router = useRouter();

const showNavbar = computed(
  () =>
    router.currentRoute.value.name != "login" &&
    router.currentRoute.value.name != "reset-password" 
);

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(showNavbar))
      ? (_openBlock(), _createBlock(NavBar, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_view)
    ])
  ]))
}
}

})